<form #formulario="ngForm">
    <mat-accordion>

        <mat-expansion-panel [expanded]="openFormCadastro" (closed)="openFormCadastro = false">
            <mat-expansion-panel-header>
                <mat-panel-title>Projetos</mat-panel-title>
            </mat-expansion-panel-header>

            <div fxLayout="row" fxFlexFill>
                <div ngModelGroup="comboPrograma" fxLayoutGap="20px" fxFlex="100">
                    <combo-projeto [showDisplayId]="false"
                                   [obrigatorio]="true"
                                   [selecionado]="projetoContrato.projeto"
                                   (valorChange)="onValorChangeProjeto($event)">
                    </combo-projeto>
                </div>
            </div>
            <div fxLayout="row" fxFlexFill>

                <mat-form-field fxLayoutGap="20px" fxFlexOffset="20px" fxFlex="100">
                    <mat-label>Data Início</mat-label>
                    <input matInput name="dataInicioProjetoContrato" [matDatepicker]="dataInicioProjetoContrato"
                           placeholder="Data Início" [(ngModel)]="projetoContrato.dataInicioProjetoContrato"
                           (input)="onMascaraDataInput($event)" maxlength="10">
                    <mat-datepicker-toggle matSuffix [for]="dataInicioProjetoContrato"></mat-datepicker-toggle>
                    <mat-datepicker #dataInicioProjetoContrato></mat-datepicker>
                </mat-form-field>

                <mat-form-field fxLayoutGap="20px" fxFlexOffset="20px" fxFlex="100">
                    <mat-label>Data Fim</mat-label>
                    <input matInput name="dataFimProjetoContrato" [matDatepicker]="dataFimProjetoContrato"
                           placeholder="Data Fim" [(ngModel)]="projetoContrato.dataFimProjetoContrato"
                           (input)="onMascaraDataInput($event)" maxlength="10">
                    <mat-datepicker-toggle matSuffix [for]="dataFimProjetoContrato"></mat-datepicker-toggle>
                    <mat-datepicker #dataFimProjetoContrato></mat-datepicker>
                </mat-form-field>

                <mat-form-field fxLayoutGap="20px" fxFlexOffset="20px" fxFlex="100">
                    <input currencyMask matInput maxlength="10" name="valorProjetoContrato" placeholder="Valor"
                           [(ngModel)]="projetoContrato.valorProjetoContrato"
                           [options]="{ prefix: '', thousands: '.', decimal: ',' }"/>
                    <span matPrefix>R$&nbsp;</span>
                </mat-form-field>


            </div>


            <div dir="rtl" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px"
                 style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>

                <button mat-raised-button name="botaoLimpar" fxFlex="20%" color="primary" (click)="limpar()">
                    Limpar
                </button>

                <button mat-raised-button name="botaoAdicionar" [disabled]="!projetoContrato?.projeto?.id" fxFlex="20%"
                        color="primary" (click)="adicionar()" *ngIf="!isAtualizarProjeto">
                    Adicionar
                </button>
                <button mat-raised-button name="botaoAlterar" [disabled]="!projetoContrato?.projeto?.id" fxFlex="20%"
                        color="primary" (click)="alterar()" *ngIf="isAtualizarProjeto">
                    Alterar
                </button>


            </div>

        </mat-expansion-panel>


        <mat-expansion-panel [expanded]="!openFormCadastro" (opened)="carregarLista()"
                             (closed)="openFormCadastro = true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Lista de Projetos ( {{ listaProjetosContrato?.length }} )
                </mat-panel-title>
            </mat-expansion-panel-header>

            <table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource"
                   style="margin-top: 20px">

                <ng-container matColumnDef="projeto">
                    <th mat-header-cell *matHeaderCellDef> Nome</th>
                    <td mat-cell *matCellDef="let element"> {{ element.projeto.nome }}</td>
                </ng-container>

                <ng-container matColumnDef="dataInicio">
                    <th mat-header-cell *matHeaderCellDef> Data início</th>
                    <td mat-cell *matCellDef="let element"> {{ element.dataInicioProjetoContrato | dataSimples }}</td>
                </ng-container>

                <ng-container matColumnDef="dataFim">
                    <th mat-header-cell *matHeaderCellDef> Data fim</th>
                    <td mat-cell *matCellDef="let element"> {{ element.dataFimProjetoContrato | dataSimples }}</td>
                </ng-container>

                <ng-container matColumnDef="valorProjeto">
                    <th mat-header-cell *matHeaderCellDef> Valor</th>
                    <td mat-cell *matCellDef="let element"> {{ element.valorProjetoContrato | currency: 'BRL' }}</td>
                </ng-container>

                <ng-container matColumnDef="acoes">
                    <th mat-header-cell *matHeaderCellDef> Ações</th>
                    <td mat-cell *matCellDef="let element">
                        <button *ngIf="perfilAcesso.deleta && listaProjetosContrato?.length >= 1" mat-button
                                (click)="deletar(element)">
                            <mat-icon>delete</mat-icon>
                        </button>
                        <button *ngIf="perfilAcesso.altera" mat-button (click)="irAtualizar(element)">
                            <mat-icon>edit</mat-icon>
                        </button>

                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

            <div [hidden]="!mostrarTabela">
                <mat-paginator [pageSizeOptions]="[5]" showFirstLastButtons></mat-paginator>
            </div>

            <ng-template #tabelaSemDados>
                <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 10px">
                    {{ msg }}
                </div>
            </ng-template>

            <div fxLayout="row" *ngIf="perfilAcesso.insere" fxLayoutAlign="end center" fxLayoutGap="16px"
                 style="padding-top: 30px">
                <div>
                    <button matTooltip="Adicionar nova projeto" mat-fab color="primary" (click)="irNovo()">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>
        </mat-expansion-panel>

    </mat-accordion>
</form>